import React from "react";
import { Box, Divider, Typography } from "@mui/material";

/**
 * FilterTable
 * - 외부 테두리 없음
 * - 행별 구분선 + 좌측 라벨 셀 배경
 */
export function FilterTable({ children }) {
    return (
        <Box
            sx={{
                width: "100%",
                bgcolor: "#fff",
            }}
        >
            <Box
                sx={{
                    borderTop: "1px solid rgba(0,0,0,0.10)",
                    borderBottom: "1px solid rgba(0,0,0,0.10)",
                }}
            >
                {children}
            </Box>
        </Box>
    );
}

/**
 * FilterRow
 * - 좌측 라벨 + 우측 컨텐츠를 “표 행”처럼 배치
 */
export function FilterRow({ label, children, noDivider }) {
    return (
        <Box>
            <Box
                sx={{
                    display: "grid",
                    gridTemplateColumns: { xs: "120px 1fr", md: "160px 1fr" },
                    alignItems: "center",
                    minHeight: 52,
                }}
            >
                <Box
                    sx={{
                        height: "100%",
                        px: 2,
                        py: 1.25,
                        bgcolor: "rgba(0,0,0,0.03)",
                        display: "flex",
                        alignItems: "center",
                        borderRight: "1px solid rgba(0,0,0,0.08)",
                    }}
                >
                    <Typography sx={{ fontSize: 13, fontWeight: 800, color: "rgba(0,0,0,0.70)" }}>
                        {label}
                    </Typography>
                </Box>

                <Box sx={{ px: 2, py: 1.25, minWidth: 0 }}>{children}</Box>
            </Box>

            {!noDivider && <Divider sx={{ borderColor: "rgba(0,0,0,0.08)" }} />}
        </Box>
    );
}